import { Injectable, inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

@Injectable()
export class ProjectsFilterForm {
  private formBuilder = inject(FormBuilder);

  public readonly fieldNames = {
    isArchived: 'isArchived',
    sortColumn: 'sortColumn'
  }

  public form: FormGroup;

  constructor() {
    this.form = this.formBuilder.group({
      isArchived: new FormControl<boolean>(false)
    });
  }
}